import { err, ErrorKind, ok, Result } from "./result";
import fetch from "./fetch";

export type Tag = (success: boolean) => void;

interface DeviceInfo {
  digits: string;
  device_type: string;
}

export async function setup(url: string): Promise<Result<DeviceInfo>> {
  return fetch(url, {
    done: (data) => {
      if (typeof data.digits !== "string") {
        return err(ErrorKind.MalformedMessage, data);
      }
      if (typeof data.device_type !== "string") {
        return err(ErrorKind.MalformedMessage, data);
      }
      return ok({ digits: data.digits, device_type: data.device_type });
    },
  });
}
